module.exports = __webpack_public_path__ + "img/mobile-menu-gashapon.e3a0f1ee.webp";